enum PaymentMethods {
    CASH = 'CASH',
    WIRE = 'WIRE',
    ADVANCE = 'ADVANCE',
}

export { PaymentMethods }
